import { useRoutes } from 'react-router-dom';
import { useAuth } from 'context/authContext';
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { protectedRoutes } from './private.routes';
import { publicRoutes } from './public.routes';
import downloadApp from '../assets/downloadApp.png';
import appOnAndroid from '../assets/appOnAndroid.png';
import appOnIos from '../assets/appOnIos.png';
import leftArrow from '../assets/leftArrow.png';
import rightArrow from '../assets/rightArrow.png';

export const AppRoutes = () => {
  const appTheme = useTheme();

  const isMobile = useMediaQuery(appTheme.breakpoints.down('sm'));

  const { isAuthenticated } = useAuth();
  const routes = isAuthenticated ? protectedRoutes : publicRoutes;
  const element = useRoutes([...routes]);

  if (isMobile) {
    return (
      <Box
        style={{
          backgroundImage: `url(${downloadApp})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '0px 8px',
          display: 'flex',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
          flex: 1,
          flexDirection: 'column',
          margin: 0,
          overflowX: 'hidden',
        }}
      >
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            zIndex: 1,
          }}
        />
        <Box
          style={{
            width: '100vw',
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
            gap: '10px',
            alignItems: 'center',
            borderRadius: '16px',
            overflow: 'hidden',
            zIndex: 2,
          }}
        >
          <Typography
            style={{
              color: '#FFF',
              fontSize: '26px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
            }}
          >
            Baixe nosso app
          </Typography>
          <Typography
            style={{ color: '#FFF', fontSize: '13px', fontWeight: 'bold' }}
          >
            escolha a opção correspondente ao seu aparelho
          </Typography>
          <Box style={{ display: 'flex', gap: '10px', marginTop: '50px' }}>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <img
                src={leftArrow}
                alt="Download arrow"
                style={{
                  marginBottom: '5px',
                  width: '80px',
                  height: '80px',
                  position: 'absolute',
                  bottom: '50%',
                }}
              />
              <Button
                onClick={() => {
                  window.open(
                    'https://apps.apple.com/br/app/simtrack/id6636496448',
                    '_blank',
                  );
                }}
                style={{
                  backgroundImage: `url(${appOnIos})`,
                  backgroundSize: 'contain',
                  width: '120px',
                  height: '40px',
                  backgroundRepeat: 'no-repeat',
                }}
              />
            </Box>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <img
                src={rightArrow}
                alt="Download arrow"
                style={{
                  marginBottom: '5px',
                  width: '80px',
                  height: '80px',
                  position: 'absolute',
                  bottom: '50%',
                }}
              />
              <Button
                onClick={() => {
                  window.open(
                    'https://play.google.com/store/apps/details?id=br.com.lwsim.monitora.cliente&pcampaignid=web_share',
                    '_blank',
                  );
                }}
                style={{
                  backgroundImage: `url(${appOnAndroid})`,
                  backgroundSize: 'contain',
                  width: '120px',
                  height: '40px',
                  backgroundRepeat: 'no-repeat',
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  return <>{element}</>;
};
